<template>
  <BaseSelector
    class="assignStrategySelector"
    :title="title"
    :options="options"
    :selectValue="selectValue"
    @selectChangeHandler="selectChangeHandler"
  ></BaseSelector>
</template>
<script>
import BaseSelector from '@/components/common/select/BaseSelector'

export default {
  props: {
    selectValue: {
      type: Number,
    },
  },
  data() {
    return {
      title: '排班策略:',
      options: [
        { value: 1, description: '直派(預設)' },
        { value: 2, description: '排班搶單策略' },
        { value: 3, description: '最近空車' },
        { value: 4, description: '直派(尾班)' },
      ],
    }
  },
  methods: {
    selectChangeHandler(value) {
      this.$emit('selectChangeHandler', value)
    },
  },
  components: {
    BaseSelector,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/select/AssignStrategySelector.vue